<template>
  <div class="w-full">
    <DatatableReportV3
      title="Timesheets"
      :source="source"
      :config="config"
      :filters="filters"
      download-url="/reports/time_cards"
      flat
    >
      <template #actions>
        <sera-button
          icon="plus"
          label="Create New"
          @click="toggleOpen"
        ></sera-button>
      </template>
      <template #column-actions="rowData">
        <TimeCardActionsMenu :time-card="parseRowData(rowData.actions)" />
      </template>
    </DatatableReportV3>
    <TimeCardModal v-if="open" @close="toggleOpen" />
  </div>
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TimeCardActionsMenu from "./TimeCardActionsMenu.vue";
import TimeCardModal from "./TimeCardModal.vue";

export default {
  components: {
    DatatableReportV3,
    TimeCardActionsMenu,
    TimeCardModal
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      open: false,
      config: {
        order: [3, "desc"],
        columns: [
          {
            data: "employee",
            searchable: false,
            orderable: false,
            aggregateTitle: "Total Employees"
          },
          { data: "role", searchable: false },
          { data: "email", searchable: false, orderable: false },
          { data: "start_time", title: "Start Time", searchable: false },
          { data: "end_time", title: "End Time", searchable: false },
          { data: "duration", searchable: false },
          { data: "last_edited", title: "Last Edited", searchable: false },
          { data: "actions", title: "", searchable: false, orderable: false }
        ]
      }
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    parseRowData(data) {
      // Parse json string
      try {
        return JSON.parse(data.replace(/&quot;/gi, '"'));
      } catch (e) {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
